var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHouse(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "house",
    xmlns: "http://www.w3.org/2000/svg",
    width: 130.04,
    height: 124.081,
    viewBox: "0 0 130.04 124.081",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M128.84,67.125,67.644,12.4a1.717,1.717,0,0,0-.348-.267,3.619,3.619,0,0,0-4.895-.08L1.206,66.778a3.618,3.618,0,0,0,4.814,5.4l11.02-9.869v63.817a9.1,9.1,0,0,0,9.094,9.094H45.445a8.538,8.538,0,0,0,8.532-8.532V94.246a1.313,1.313,0,0,1,1.311-1.311h19.5A1.313,1.313,0,0,1,76.1,94.246V126.69a8.538,8.538,0,0,0,8.532,8.532h19.311c5.082,0,9.094-5,9.094-11.394V62.659l11.02,9.869a3.637,3.637,0,0,0,5.109-.294A3.682,3.682,0,0,0,128.84,67.125Zm-23.055,17.84v38.809c0,2.594-1.284,4.172-1.872,4.172H84.6a1.313,1.313,0,0,1-1.311-1.311V94.246a8.538,8.538,0,0,0-8.532-8.532h-19.5a8.538,8.538,0,0,0-8.532,8.532V126.69A1.313,1.313,0,0,1,45.418,128H26.107a1.878,1.878,0,0,1-1.872-1.872V55.838l40.6-36.268,40.949,36.616V84.965Z",
    transform: "translate(0 -11.141)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHouse);
export default __webpack_public_path__ + "static/media/house.4ec69063.svg";
export { ForwardRef as ReactComponent };